import React from 'react'
import { connect } from 'react-redux'
import { createNewPlaylistEntry } from '../../redux/actions/playlistEntries'
import {
  featurePlanEntry,
  unfeaturePlanEntry
} from '../../redux/actions/planEntries'
import { userAuthoredPlaylists } from '../../redux/selectors/playlists'
import { currentUser } from '../../redux/selectors/user'
import ThreeDotHoverMenu from '../nestedHoverMenu/ThreeDotHoverMenu'
import { getPlaylistEntries } from '../../redux/selectors/playlistEntries'
import PlanEntryOptionsModal from './PlanEntryOptionsModal'
import PropTypes from 'prop-types'
import AloModal from '../AloModal'
import ShareModalContent from '../shareModal/ShareModalContent'

class PlanEntryOptions extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      openModal: ''
    }

    this.planEntryInPlaylist = this.planEntryInPlaylist.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  hideModal () {
    this.setState({ openModal: '' })
  }

  planEntryInPlaylist (playlist) {
    return this.props.playlistEntries
      .filter({
        playlist: playlist.uuid,
        planEntry: this.props.planEntry.id
      })
      .exists()
  }

  generateMenuOptions () {
    let entryMenuOptions = [
      {
        text: 'Share Class',
        handleClick: () => {
          this.setState({ openModal: 'share' })
        }
      }
    ]

    if (this.props.currentUser) {
      entryMenuOptions = entryMenuOptions.concat([
        {
          text: 'Add To Playlist',
          children: this.props.playlists.map(playlist => {
            const entryInPlaylist = this.planEntryInPlaylist(playlist)
            return {
              text: playlist.title,
              included: entryInPlaylist,
              handleClick: () => {
                this.props.addToPlaylist(playlist.uuid)
              }
            }
          })
        }
      ])
    }

    if (this.props.removable) {
      entryMenuOptions = entryMenuOptions.concat([
        {
          text: 'Remove From Playlist',
          handleClick: this.props.onDelete
        }
      ])
    }

    if (this.props.featurable) {
      entryMenuOptions = entryMenuOptions.concat([
        {
          text: this.props.planEntry.featured ? 'Unfeature' : 'Feature',
          handleClick: () => {
            if (this.props.planEntry.featured) {
              this.props.planEntry.unfeature().then(() => {
                this.props.unfeaturePlanEntry()
              })
            } else {
              this.props.planEntry.feature().then(() => {
                this.props.featurePlanEntry()
              })
            }
          }
        }
      ])
    }

    return entryMenuOptions
  }

  render () {
    const entryMenuOptions = this.generateMenuOptions()

    return (
      <div className='PlanEntryOptions'>
        <div className='hidden-xs'>
          <ThreeDotHoverMenu menuOptions={entryMenuOptions} />
        </div>
        <div className='visible-xs'>
          <div
            style={{ border: 0 }}
            className='hover-dots-circle'
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              this.setState({ openModal: 'options' })
            }}
          />
        </div>

        <AloModal
          show={this.state.openModal === 'share'}
          onHide={this.hideModal}
        >
          <ShareModalContent
            item='Class'
            urlToShare={this.props.planEntry.planEntryUrl}
            onHide={this.hideModal}
          />
        </AloModal>

        <PlanEntryOptionsModal
          show={this.state.openModal === 'options'}
          onHide={this.hideModal}
          planEntry={this.props.planEntry}
          playlists={this.props.playlists}
          playlistEntries={this.props.playlistEntries}
          onPlaylistSelect={playlist => {
            this.props.addToPlaylist(playlist.uuid)
          }}
          planEntryInPlaylist={this.planEntryInPlaylist}
          onDelete={this.props.onDelete}
        />
      </div>
    )
  }
}

PlanEntryOptions.propTypes = {
  playlists: PropTypes.array,
  currentUser: PropTypes.object,
  playlistEntries: PropTypes.object,
  addToPlaylist: PropTypes.func,
  featurePlanEntry: PropTypes.func,
  unfeaturePlanEntry: PropTypes.func,
  planEntry: PropTypes.object,
  onDelete: PropTypes.func,
  removable: PropTypes.bool
}

const mapStateToProps = state => {
  return {
    playlists: userAuthoredPlaylists(state),
    currentUser: currentUser(state),
    playlistEntries: getPlaylistEntries(state)
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    addToPlaylist: uuid => {
      dispatch(createNewPlaylistEntry(uuid, props.planEntry.id))
    },
    featurePlanEntry: () => {
      dispatch(featurePlanEntry(props.planEntry.id))
    },
    unfeaturePlanEntry: () => {
      dispatch(unfeaturePlanEntry(props.planEntry.id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanEntryOptions)
